import * as React from "react";
import { cn } from "@/lib/utils";

interface ToggleWithLabelProps {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}

export function ToggleWithLabel({
  id,
  checked,
  onChange,
  label,
  leftIcon,
  rightIcon
}: ToggleWithLabelProps) {
  return (
    <div className="flex items-center justify-between gap-6">
      <div className="flex items-center gap-3">
        {leftIcon}
        <label
          htmlFor={id}
          className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
        >
          {label}
        </label>
      </div>
      <div className="relative">
        <input
          type="checkbox"
          id={id}
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="sr-only"
        />
        <div
          className={cn(
            "relative w-[43px] h-[22px] rounded-full transition-colors duration-200 ease-in-out cursor-pointer",
            checked 
              ? "bg-[#8B5CF6]" 
              : "bg-[#E5E7EB]"
          )}
          onClick={() => onChange(!checked)}
        >
          <div
            className={cn(
              "absolute top-[2px] w-[18px] h-[18px] bg-white rounded-full shadow-sm transition-transform duration-200 ease-in-out",
              checked 
                ? "left-[23px] shadow-[0_2px_4px_rgba(139,92,246,0.2)]" 
                : "left-[2px] shadow-[0_2px_4px_rgba(0,0,0,0.1)]"
            )}
          />
        </div>
      </div>
    </div>
  );
}